module.exports = __WEBPACK_EXTERNAL_MODULE_12__;


//////////////////
// WEBPACK FOOTER
// external {"root":"L","commonjs":"leaflet","commonjs2":"leaflet","amd":"leaflet"}
// module id = 12
// module chunks = 0 1